<template>
  <div class="searchContainer">
    <input
      v-model="searchString"
      data-automation="search-input"
      :placeholder="placeholder"
      type="text"
    >
    <div
      v-if="searchString.length"
      data-automation="search-cancel"
      class="searchKiller"
      @click="clearSearch"
    />
  </div>
</template>

<script>

import debounce from 'debounce'

export default {
  name: 'Search',
  props: {
    initValue: {
      type: String,
      required: false,
      default: '',
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
  },
  data: function () {
    return {
      searchString: this.initValue,
    }
  },
  watch: {
    searchString: function (value) {
      this.tellParent()
    },
    initValue: function (value) {
      if (!value) {
        this.clearSearch()
        return
      }

      this.searchString = value
    },
  },
  created: function () {
    // Debounce search by 300ms
    this.tellParent = debounce(this.tellParent, 300)
  },
  methods: {
    clearSearch: function (event) {
      this.searchString = ''
    },
    tellParent: function () {
      this.$emit('searchChange', this.searchString)
    },
  },
}

</script>
